import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Form, Input, Button, message, Icon,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../util/react';
import { msgCB } from '../../../util/fetch/msgFetch';
import { CB_STATUS } from '../../../util/fetch/cFetch';
import { actUI } from '../../../redux/action/ui';

const FormItem = Form.Item;

export class NewForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      intl, form, onSubmit, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, {
        uiHome: {
          uiFormPassword: { loading: false },
        },
      });
      switch (res.status) {
        case CB_STATUS.INVALID:
          message.config({
            top: 100,
            icon: <Icon type="close-circle" theme="filled" />,
          });
          return message.error(
            formatMessage({
              id: 'Header.wrongPassword',
              defaultMessage: 'password is not correct',
            }),
          );
        default:
          return msgCB(res.status, formatMessage);
      }
    };
    form.validateFields((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        actUI(dispatch, {
          uiHome: {
            uiFormPassword: { loading: true },
          },
        });
        onSubmit(
          {
            current_password: values.currentPassword,
            password: values.newPassword,
          },
          cb,
        );
      }
    });
  };

  checkConfirm = (rule, value, callback) => {
    const { form, intl } = this.props;
    const { formatMessage } = intl;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback(
        formatMessage({
          id: 'app.pw.checkInconsistent',
          defaultMessage: 'two passwords are not consistent',
        }),
      );
    } else {
      callback();
    }
  };

  render() {
    const {
      intl,
      form,
      filePath,
      className,
      ui,
    } = this.props;
    const { formatMessage } = intl;
    const { getFieldDecorator } = form;

    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={`${filePath} ${className}`}
      >
        <FormItem
          label={formatMessage({
            id: 'app.pw.currentPassword',
            defaultMessage: 'current password',
          })}
        >
          {getFieldDecorator('currentPassword', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Header.currentPasswordCheck',
                  defaultMessage: 'please input current password',
                }),
              },
              {
                max: 20,
                min: 5,
                message: formatMessage({
                  id: 'validator.invalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
            ],
          })(<Input type="password" maxLength={20} />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'app.pw.newPassword',
            defaultMessage: 'new password',
          })}
        >
          {getFieldDecorator('newPassword', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Header.newPasswordCheck',
                  defaultMessage: 'please input new password',
                }),
              },
              {
                max: 18,
                min: 8,
                message: formatMessage({
                  id: 'password.invalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
              {
                // pattern: /^[A-Za-z0-9]*$/,
                // pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,18}$/,
                pattern: /(?!.*\s)(?!^[0-9]+$)(?!^[A-Z]+$)(?!^[a-z]+$)(?!^[^A-z0-9]+$)^.{8,18}$/,
                message: formatMessage({
                  id: 'validator.pwdRule',
                  defaultMessage: 'Special charactor, upper case letters and lower char letters and digital is required!',
                }),
              },
            ],
          })(<Input type="password" maxLength={18} />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'app.pw.confirmPassword',
            defaultMessage: 'confirm password',
          })}
        >
          {getFieldDecorator('confirmPassword', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Header.confirmPasswordCheck',
                  defaultMessage: 'please input password again',
                }),
              },
              {
                validator: this.checkConfirm,
              },
            ],
          })(<Input type="password" maxLength={18} />)}
        </FormItem>
        <FormItem className="btn-area">
          <Button
            type="primary"
            htmlType="submit"
            loading={ui.loading}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Form.create()(
  wrapReact(NewForm, 'container_index_header_menu_menuUser_FormPassword'),
);
